import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropzone",staticClass:"file-drop-zone"},[_c('div',{staticClass:"zone",class:{'hidden': !_vm.isFileOver}},[_c('div',{staticClass:"bordered"},[_c(VIcon,{staticClass:"upload-icon"},[_vm._v("cloud_upload")]),_vm._v("\n      Release files to upload...\n    ")],1)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }